import { Grid, makeStyles } from '@material-ui/core'
import { Elements, TextButton, TextInput } from '@tfo/common'
import { observer } from 'mobx-react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import '../../client/views/reports/components/reports-list/ReportsList.scss'
import '../myaccount.scss'
import { useStore } from '../../../hooks/useStore'
import $http from '../../../utils/$http'
import { IUser } from '@tfo/common/src/stores/UserStore'
import { LoginMethod } from '../../../models/enums/LoginMethod'

const useStyle = makeStyles({
	label: {
		marginBottom: '10px',
	},
	divider: {
		boxSizing: 'border-box',
		height: '0.67px',
		border: '1px solid #DFDFDE',
		marginTop: '50px',
		marginBottom: '50px',
	},
})

export const MyAccountsInformation = observer(() => {
	type UserInfo = {
		firstName: string
		lastName: string
		email: string
		phoneNumber: string
	}
	
	const intl = useIntl()
	const { userStore } = useStore()
	const { Label } = Elements
	const classes = useStyle()
	const [user, setUser] = React.useState<UserInfo>()
	const isSSO = userStore.user.loginType === LoginMethod.SSO
	React.useEffect(() => {
		getUser()
	}, [])

	const [responseMessage, setResponseMessage] = React.useState('')

	const getUser = async () => {
		const user = await $http.get<UserInfo>(`/user/customer/${userStore.userId}`)
		setUser(() => ({firstName: user.firstName, lastName: user.lastName, email: user.email, phoneNumber: user.phoneNumber }))
	}
	
	const save = async () => {
		await $http.put<any>(`/user/customer/myaccount-info/`, user)
			.then(() => {
				getUser()
				setResponseMessage(intl.formatMessage({ id: 'response.saved' }))
				setTimeout(() => {
					setResponseMessage('')
				}, 3000)
			})
			.catch(err => {
				console.error(err)
				window.alert(err)
			})
	}

	return (
		<div className="myaccount-info">
			{/* SSO Restriction Message */}
			{isSSO && (
				<Grid container spacing={3} direction="row" className="sso-restriction-container">
					<Grid item xs={6}>
						{/* Empty left side */}
					</Grid>
					<Grid item xs={6}>
						<div className="sso-restriction-message">
							<p>
								{intl.formatMessage({ id: 'common.user.information.sso.restricted' })}
							</p>
						</div>
					</Grid>
				</Grid>
			)}
			<Grid container spacing={3} direction="row">
				<Grid item xs={6}>
					{/* An empty grid in case we want to add content on the left side*/}
				</Grid>
				<Grid container item xs={6} direction="column">
					<Grid item>
						<div className={'NewReportOrder__BlockSpace--medium'}>
							<Label className={classes.label}>
								{intl.formatMessage({ id: 'neworder.firstname.placeholder' })}
							</Label>
							<TextInput
								id="firstname"
								value={user?.firstName || ''}
								disabled={isSSO}
								onChange={event =>
									setUser({ ...user, firstName: event.target.value })
								}
							/>
						</div>
					</Grid>
					<Grid item>
						<div className={'NewReportOrder__BlockSpace--medium'}>
							<Label className={classes.label}>
								{intl.formatMessage({ id: 'neworder.lastname.placeholder' })}
							</Label>
							<TextInput
								id="lastname"
								value={user?.lastName || ''}
								disabled={isSSO}
								onChange={event =>
									setUser({ ...user, lastName: event.target.value })
								}
							/>
						</div>
					</Grid>
					<Grid item>
						<div className={'NewReportOrder__BlockSpace--medium'}>
							<Label className={classes.label}>
								{intl.formatMessage({ id: 'neworder.email.placeholder' })}
							</Label>
							<TextInput disabled id="epost" value={user?.email || ''} />
						</div>
					</Grid>
					<Grid item>
						<div className={'NewReportOrder__BlockSpace--medium'}>
							<Label className={classes.label}>
								{intl.formatMessage({
									id: 'checkpoint.referencePerson.phoneNumer',
								})}
							</Label>
							<TextInput
								id="phoneNumber"
								value={user?.phoneNumber || ''}
								disabled={isSSO}
								onChange={event =>
									setUser({ ...user, phoneNumber: event.target.value })
								}
							/>
						</div>
					</Grid>

					<Grid item>
						<div className={'NewReportOrder__BlockSpace--medium'}>
							<TextButton
								className="save-button"
								color="primary"
								disabled={isSSO}
								onClick={() => {
									save()
								}}>
								{intl.formatMessage({
									id: 'common.save',
								})}
							</TextButton>
						</div>
					</Grid>

					<Grid item>
						<div className={'NewReportOrder__BlockSpace--medium'}>
							<Label className={classes.label}>{responseMessage}</Label>
						</div>
					</Grid>
				</Grid>
			</Grid>
		</div>
	)
})

export default MyAccountsInformation
